import React from 'react';
import '../../App.css';

function FAQ() {
  return (
    <>
    <h1 className='faq_title'>FREQUENTLY ASKED QUESTIONS</h1>

    <h2 className='faq_bold'>How do I pay?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>We will be taking payment via Lydia only. If you are unable to download Lydia, and unable to find someone to buy you a ticket, let us know and we will sort something out ;). </h2>

    <h2 className='faq_bold'>How do I get a refund?</h2>
    <h2 className='faq_note'>Email us at wakeimt2022@gmail.com ! </h2>

    <h2 className='faq_bold'>What is a delegation?</h2>
    <h2 className='faq_note'>A group of 30 people or so coming originally from the same geographical region. Once we confirm your attendance to the WAKE through email, you will be put in a group of 30 people according to your continent of origin. To win the competition your delegation should be full of talented people as well as fierce athletes, ideally combine the two! Most importantly, you should develop a good cohesion and have fun meeting new people. </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>Can I compete more than once in Mundovision and World’s Got Talent?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Yes! </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>What is Mundovision?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>A singing contest ! </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>What is World’s Got Talent?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>A talent contest ! Magic, dance, storytelling, traditional art, whatever ! (no singing as it is reserved to the Mundovision) </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>Which sports are there?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Basketball, Badminton, Volley-ball, Futsal, Table-tennis, Opening relay.  </h2>

    <h2 className='faq_note' style={{ flexWrap: 'wrap'}}>Please note: Your delegation should count 30 participants. In order to compete in all sports and win the maximum number of points, some participants should be polyvalent athletes and be ready to compete in more than one sport. </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>Do I have to compete in all the sports? </h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Not at all ! You’ll have to decide with your delegation of who plays what sport </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>Is food going to be provided? </h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Yes ! Everything from breakfast to dinner ! </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>What is included in my ticket price?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Food, pass to the evening, sports competitions </h2>

    <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>If you are not from Nantes:</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Transport to and from the train station of Rennes/Brest depending on your campus of origin.<br/><br/>
Accommodation in the CERISE Hotel La Beaujoire will be offered too (ONLY if you can’t be hosted by someone in Nantes).
 </h2>

 <h2 className='faq_bold' style={{flex: 1, flexWrap: 'wrap'}}>How do I get to IMT Atlantique Nantes' campus?</h2>
    <h2 className='faq_note' style={{flex: 1, flexWrap: 'wrap'}}>Transport to and from the train station of Rennes/Brest depending on your campus of origin will lead you to the train station of Nantes.<br/><br/>
Then you’ll have to take to T1 tramway until the Terminus (Ranzay or Beaujoire).<br/><br/>
Then take the C6 bus (direction “Chantrerie Grandes écoles”) until the terminus

 </h2>
    </>

  );
}

export default FAQ;
